
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[appName]/signup",
      function () {
        return require("private-next-pages/[appName]/signup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[appName]/signup"])
      });
    }
  